<div class="consult-table-section">
  <div class="consult-table-shell">
    <ng-container *ngIf="itens.length > 0; else emptyTableState">
      <b3-table
        size="sm"
        background="striped"
        aria-label="Lista de posição de créditos de carbono"
        [attr.aria-rowcount]="totalItens"
        aria-colcount="7">
        <b3-table-rowgroup group="header">
          <b3-table-row>
            <b3-table-cell-header [label]="headerAccountLabel"></b3-table-cell-header>
            <b3-table-cell-header [label]="headerInstrumentLabel"></b3-table-cell-header>
            <b3-table-cell-header label="Posição"></b3-table-cell-header>
            <b3-table-cell-header [label]="headerProjectLabel"></b3-table-cell-header>
            <b3-table-cell-header label="Serial Range"></b3-table-cell-header>
            <b3-table-cell-header label="Comitente"></b3-table-cell-header>
            <b3-table-cell-header label="Detalhes" align="center"></b3-table-cell-header>
          </b3-table-row>
        </b3-table-rowgroup>

        <b3-table-rowgroup group="body">
          <b3-table-row
            *ngFor="let position of itens; trackBy: trackByPosition"
            [id]="'position-consult-row-' + position.carbonCreditCode">
            <b3-table-cell variant="text" [label]="position.accountCode || '-'"></b3-table-cell>
            <b3-table-cell variant="text" [label]="position.carbonCreditCode || '-'"></b3-table-cell>
            <b3-table-cell variant="text" [label]="getPositionQuantityLabel(position)"></b3-table-cell>
            <b3-table-cell variant="text" [label]="getProjectIdLabel(position)"></b3-table-cell>
            <b3-table-cell variant="text" [label]="getSerialLabel(position)"></b3-table-cell>
            <b3-table-cell variant="text" [label]="getComitenteLabel(position)"></b3-table-cell>
            <b3-table-cell variant="slot">
              <div class="consult-table-actions">
                <b3-tooltip label="Detalhes" variant="single-line" pointer="bottom">
                  <b3-button
                    type="button"
                    variant="ghost"
                    tone="default"
                    size="sm"
                    [attr.aria-label]="getDetailsLabel(position)"
                    (b3-click)="openDetail(position)">
                    <b3-icon name="visibility"></b3-icon>
                  </b3-button>
                </b3-tooltip>
              </div>
            </b3-table-cell>
          </b3-table-row>
        </b3-table-rowgroup>
      </b3-table>
    </ng-container>

    <ng-template #emptyTableState>
      <app-consult-table-empty-state></app-consult-table-empty-state>
    </ng-template>
  </div>

  <div class="consult-table-pagination" *ngIf="totalItens > 0">
    <p class="consult-table-pagination__info">{{ recordsPerPageLabel }}</p>
    <b3-pagination
      *ngIf="totalPages > 1"
      aria-label="Paginação da consulta de posição"
      variant="numbers"
      navigation="icon"
      overflow
      [attr.total]="totalPages"
      [attr.current]="pagination.page ?? 1"
      (b3-change)="onPaginationChange($event)">
    </b3-pagination>
  </div>
</div>
